import { getJSONByUrl } from 'widgets/toolbox/ajax';

export type TApplePayConfig = {
    merchantId: string;
    merchantName: string;
};

export type TAdyenPaymentMethod = {
    brands: Array<string>;
    name: string;
    type: string;
    configuration?: TApplePayConfig;
};

export type TAdyenPaymentMethods = Array<TAdyenPaymentMethod>;

// Shared cache for payment methods request promise to avoid multiple requests for the same URL.
// The key is the payment methods URL, and the value is the promise that resolves to the payment methods response.
const paymentMethodsPromiseCache: Map<string, Promise<{ adyenPaymentMethods: TAdyenPaymentMethods }>> = new Map();

/**
 * @description Requests payment methods from the server and returns a promise with the response. The response is cached, so subsequent calls will return the same promise until the page is refreshed.
 * @param paymentMethodsUrl URL to request payment methods from
 * @returns Promise resolving to an object containing Adyen payment methods
 */
export function requestPaymentMethods(paymentMethodsUrl: string): Promise<{ adyenPaymentMethods: TAdyenPaymentMethods }> {
    if (!paymentMethodsPromiseCache.has(paymentMethodsUrl)) {
        const requestPromise = getJSONByUrl(paymentMethodsUrl).catch(() => {
            paymentMethodsPromiseCache.delete(paymentMethodsUrl);

            return { adyenPaymentMethods: [] };
        });

        paymentMethodsPromiseCache.set(paymentMethodsUrl, requestPromise);
    }

    return paymentMethodsPromiseCache.get(paymentMethodsUrl)!;
}
